import pb, { ResizeType } from "@bitpatty/imgproxy-url-builder";
import React, { useEffect, useState } from "react";

const KEY = "D98C27E5994DAC1C8108C9110C9BB5FAEDC779BC9B1CE0FF32213448A0AB90B2";
const SALT = "E272ED7300D88721F74C419963619350BB585F01788E522F63BE2346FC7E5C0E";
const BASE_URL = "https://th.forthepeople.ai";

type ThumbnailProps = {
  s3Key: string;
  bucket: string;
  width: number;
  height: number;
  fit?: "FILL" | "FIT" | "FORCE" | "AUTO" | "FILL_DOWN";
  className?: string;
  cacheKey?: string | number;
};

const ThumbnailImage = (props: ThumbnailProps) => {
  const [thumbnail, setThumbnail] = useState<string | null>(null);
  const { s3Key, bucket, width, height, fit = "FILL", cacheKey, className } = props;

  useEffect(() => {
    try {
      let url = pb()
        .resize({
          type: ResizeType[fit],
          width,
          height,
        })
        .build({
          path: `s3://${bucket}/${s3Key}`,
          signature: {
            key: KEY,
            salt: SALT,
          },
          baseUrl: BASE_URL,
        });

      if (cacheKey !== undefined) {
        url += (url.includes("?") ? "&" : "?") + `v=${cacheKey}`;
      }

      setThumbnail(url);
    } catch (e) {
      console.error(e);
    }
  }, [s3Key, cacheKey, bucket, width, height, fit]);

  const isFit = fit === "FIT";

  return (
    <img
      src={thumbnail || undefined}
      alt="thumbnail"
      width={isFit ? undefined : width}
      height={isFit ? undefined : height}
      className={
        className ||
        (isFit
          ? "max-h-full max-w-full h-auto w-auto object-contain rounded-md"
          : "object-cover rounded-md")
      }
    />
  );
};

export default ThumbnailImage;